import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";
import MetaComponent from "../../../components/common/metaComponent";
import {
    OrganizationsWrapper,
} from "./orgnization";
import SearchBox from "../../../components/common/searchBox/searchBox";
import { useSelector } from "react-redux";

const Organizations = () => {

    let token = typeof localStorage !== "undefined" && localStorage.getItem("token");
    const data = useSelector((state: any) => state?.flag.flag);

    return (
        <>
            <MetaComponent
                keywords=""
                description=""
                ogTitle="Donations for Nonprofits | GreatNonprofits"
                ogDescription=""
                ogUrl="https://www.about.greatnonprofits.org/donations"
                ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
            />

            <>
                <OrganizationsWrapper>
                    <Container>
                        {token && data && (
                            <ul className="red-alert-text">
                                <li>
                                    <p>
                                        Thanks for registering at GreatNonprofits. You still need to claim your organization by finding it and clicking the claim button. If your organization is unlisted, you can also add it. Please contact us if you have any questions.
                                    </p>
                                </li>
                            </ul>
                        )}

                        {token && (
                            <ul className="greent-text">
                                <li>
                                    <p>Search using your organization’s name, EIN and/or location. EIN is the most accurate way to find your nonprofit profile.</p>
                                </li>
                            </ul>
                        )}

                        {/* {token && <>{data && <><ul className="red-alert-text">

                            <li>
                                <p >
                                    Thanks for registering at GreatNonprofits. You still need to claim your organization by finding it and clicking the claim button. If your organization is unlisted you can also add it. Please contact us if you have any questions.
                                </p>
                            </li>

                        </ul>
                        </>}
                            <ul className="greent-text">
                                <li>
                                    <p>Search using your organization’s name, EIN and/or location. EIN is the most accurate way to find your nonprofit profile.</p>

                                </li>
                            </ul>
                        </>
                        } */}
                        <h1>Find A Nonprofit</h1>
                        <p>Review and donate to nonprofits such as museums, animal shelters, youth programs and more!</p>

                        <p>GreatNonprofits is your single destination for nonprofit giving. Give to your favorite nonprofits quickly and easily and track all your charitable giving in one place for easy tax preparation.</p>
                        <SearchBox />
                    </Container>
                </OrganizationsWrapper>

            </>
        </>
    )
};
export default Organizations;